import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Registrant} from '@/model/registrant.model';
import {ApiService} from '@services/api.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {MassService} from '@pages/dashboard/mass.service';
import {Subject} from 'rxjs';
import Swal from 'sweetalert2';
import {DataTableDirective} from 'angular-datatables';

@Component({
  selector: 'app-registrant-pre',
  templateUrl: './registrant-pre.component.html',
  styleUrls: ['./registrant-pre.component.scss']
})
export class RegistrantPreComponent implements OnInit, OnDestroy {
  isLoading: boolean = false;
  massid: string;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  registrantList: Registrant[] = [];
  registrantListError: boolean = false;
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  initialLoad: boolean = true;


  constructor(private route: ActivatedRoute, private apiService: ApiService, private router: Router, private massService: MassService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.dtOptions ={
      responsive: true,
      autoWidth: false,
      columnDefs: [
        { responsivePriority: 0, targets: -1 },
        { responsivePriority: 0, targets: 3 },
        { responsivePriority: 1, targets: 4 }
      ],
      dom: 'Bfrtipl',
      buttons: ["copy",
        {
          extend: 'csvHtml5',
          title: 'MRS_Mass_Pre-Registrant_List'
        },
        {
          extend: 'excelHtml5',
          title: 'MRS_Mass_Pre-Registrant_List'
        },
        {
          extend: 'pdfHtml5',
          messageBottom: 'Church of the Visitation Seremban. All Rights Reserved.',
          title: 'MRS_Mass_Pre-Registrant_List'
        },
        "print",
        "colvis"]
    }
    this.route.parent.params.subscribe(
      (params: Params) =>{
        this.massid = params.massid;
        this.getPreRegistrants();
      }
    )
  }

  getPreRegistrants(){
    this.apiService.fetchAllRegistrants(this.massid).subscribe(resData =>{
      this.isLoading = false;
      this.massService.setRegistrants(resData);
      this.registrantList = this.massService.getRegistrants();
      if(this.initialLoad){
        this.dtTrigger.next();
        this.initialLoad = false;
      }else{
        this.massService.massRegistered.next(this.registrantList.length);
        this.rerender();
      }
    }, errorMessage => {
      this.isLoading = false;
      this.registrantListError = true;
    })
  }

  registerMethodConverter(reg_method: string): string{
    if(reg_method === 'A'){
      return 'ADMIN';
    }else if(reg_method === 'P'){
      return 'PRE-REG'
    }else if(reg_method === 'W'){
      return 'WALK-IN'
    }else if(reg_method === 'I'){
      return 'IMPORT'
    }else if(reg_method === 'S'){
      return 'SELF-CHECKIN'
    }else if(reg_method === 'H'){
      return 'ADMIN CHECKIN'
    }
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  onCancelRegistrant(reg_id: string){
    Swal.fire({
      title: 'Cancel Registration?',
      text: "This registrant will be moved to the \"Cancelled\" section!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, cancel registration!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        const jsonBody: Object ={
          "reg_id" : reg_id,
          "mass_id" : this.massid
        }
        this.apiService.cancelPreRegistrant(jsonBody).subscribe(resData => {
          Swal.fire({
            title: 'Done!',
            text: "Registration Cancelled.",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK'
          });
          this.getPreRegistrants();
        },errorMessage =>{
          Swal.fire({
            title: 'Opps...',
            text: errorMessage.error.message,
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK'
          });
        })
      }
    })
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
}
